module.exports = __webpack_public_path__ + "img/diamond_banner_bacarat.35639149.png";